import React from 'react';
import { Container, Typography } from '@mui/material';
import DeliveryPersonPolicyBox from '../components/DeliveryPersonPolicyBox';

export default function DriverPolicyPage() {
    
    // --- 1. Customer Interaction / Service Rules ---
    const serviceRules = [
        "Maintain a professional and courteous demeanor with all customers.",
        "Always verify the recipient's identity for orders containing age-restricted items.",
        "Wait a maximum of 5 minutes for the customer before proceeding to the next stop.",
        "Handle all packages with care and never leave them exposed to weather.",
    ];

    // --- 2. Safety and Vehicle Rules ---
    const safetyRules = [
        "Mandatory vehicle inspection and pre-trip checklist must be completed daily.",
        "No cell phone use is permitted while the vehicle is in motion.",
        "Report all accidents, large or small, to dispatch immediately.",
    ];
    
    return (
        <Container maxWidth="md" sx={{ mt: 4 }}>
            <Typography variant="h4" gutterBottom>
                Delivery Personnel Operating Manual
            </Typography>

            {/* Display Service Standards */}
            <DeliveryPersonPolicyBox 
                title="Customer Service & Interaction Guidelines" 
                rules={serviceRules} 
                type="service" // Uses standard blue color and truck icon
            />

            {/* Display Safety Rules */}
            <DeliveryPersonPolicyBox 
                title="Vehicle & Road Safety Protocols" 
                rules={safetyRules} 
                type="safety" // Uses red color and security icon
            />
            
        </Container>
    );
}